import { useAuth } from '@skyslope/auth-react';
import { useMutation } from '@tanstack/react-query';

import type { DismissIntegrationsRequest, IntegrationEnablement } from 'resources/server/IntegrationsServer';
import IntegrationsServer from 'resources/server/IntegrationsServer';

export function useDismissIntegrationDialog() {
  const { userContext } = useAuth();

  return useMutation({
    mutationFn: async (args: DismissIntegrationsRequest): Promise<IntegrationEnablement[]> => {
      if (!userContext?.id) throw new Error('User ID is required');
      return await IntegrationsServer.DismissIntegrations({ userId: userContext.id, body: args });
    },
  });
}
